const shape = (fontFamily) => ({
    borderRadius: 4
});
export default shape;
